// extracted by mini-css-extract-plugin
export default {"container":"login_container__P0FSm","mobileMoneyLogosRow":"login_mobileMoneyLogosRow__ZygSA","mobileMoneyLogo":"login_mobileMoneyLogo__H+mD8"};